// extracted by mini-css-extract-plugin
export default {"cards-row":"Trending_cards-row__QGyMN","col":"Trending_col__kwA9X","mid-heading":"Trending_mid-heading__ZehQe"};